import config from '../../config';
import { useAxios } from '../useAxios';
import { useInfiniteQuery, useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { createCriteria, deleteCriteria, getCriteria, getCriterias, updateCriteria } from '../../services/api/criteria';
import { CategoryDataType, ICriteria } from '@recone/models';

export const GET_CRITERIAS_QUERY_ID = 'criteria/list';

export function useGetCriteria(criteriaId: string) {
  const axios = useAxios();

  return useQuery([GET_CRITERIAS_QUERY_ID, criteriaId], () => getCriteria(axios, criteriaId), {
    enabled: !!criteriaId
  });
}

export function useGetCriterias(limit = config.service.QUERY_DEFAULT_LIMIT) {
  const axios = useAxios();

  return useInfiniteQuery([GET_CRITERIAS_QUERY_ID], ({ pageParam }) => getCriterias(axios, pageParam, limit), {
    getNextPageParam: (lastData, pages) => pages.length
  });
}

export function useCreateCriteria() {
  const axios = useAxios();
  const queryClient = useQueryClient();

  return useMutation(
    (args: { name: string; description: string; filters: string | CategoryDataType[] }) =>
      createCriteria(axios, args.name, args.description, args.filters),
    {
      onSuccess: () => {
        queryClient.invalidateQueries([GET_CRITERIAS_QUERY_ID]).then();
      }
    }
  );
}

export function useUpdateCriteria(criteriaId: string) {
  const axios = useAxios();
  const queryClient = useQueryClient();

  return useMutation((args: { criteria: Partial<ICriteria> }) => updateCriteria(axios, criteriaId, args.criteria), {
    onSuccess: () => {
      queryClient.invalidateQueries([GET_CRITERIAS_QUERY_ID]).then();
    }
  });
}

export function useDeleteCriteria() {
  const axios = useAxios();
  const queryClient = useQueryClient();

  return useMutation((args: { criteriaId: string }) => deleteCriteria(axios, args.criteriaId), {
    onSuccess: () => {
      queryClient.invalidateQueries([GET_CRITERIAS_QUERY_ID]).then();
    }
  });
}
